import type { Locale } from 'vue-i18n'

function toLocale(lang: string): Locale {
  if (lang === 'en')
    return 'en'
  return 'de'
}

export function handleLocale(lang?: string): void {
  const localLang = useLocalStorage<string | undefined>('lang', undefined)

  const { defaultLocale, availableLocales, setLocale, getBrowserLocale } = useI18n()

  const langLocale = toLocale(lang ?? 'de')
  const localLangLocale = toLocale(localLang.value ?? 'de')

  function setLanguage(lang: Locale): void {
    setLocale(lang)
    localLang.value = lang
  }

  if (lang !== undefined && availableLocales.includes(langLocale))
    return setLanguage(langLocale)

  if (localLang.value && availableLocales.includes(localLangLocale))
    return setLanguage(localLangLocale)

  const browser = getBrowserLocale()
  const browserLocale = toLocale(browser ?? 'de')
  if (browser !== undefined && availableLocales.includes(browserLocale))
    return setLanguage(browserLocale)

  setLanguage(defaultLocale)
}
